import { createActions, createReducer } from 'reduxsauce';
import { schema } from 'normalizr';
import {
  EXTEND_NORMALIZED_INITIAL_STATE,
  FAVOURITE_ACTIONS_SET,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getExtendNormalized,
  getSuccessListHandler,
  getFailureHandler,
  softRemoveHandler,
  toggleFavourite,
} from '../../../store/structures';
import { types as detailsTypes } from '../details/duck';

const favCoupons = new schema.Entity('favCoupons');

// Define action types and creators
export const { Types: types, Creators: actions } = createActions(
  {
    getAllFavouriteList: ['params'],
    reloadFavourites: null,
    ...PAGINATED_ACTIONS_SET,
    ...FAVOURITE_ACTIONS_SET,
  },
  {
    prefix: 'cb/coupons/favourites/',
  },
);

// Handlers
export const HANDLERS = {
  [types.REQUEST]: getRequestHandler(EXTEND_NORMALIZED_INITIAL_STATE),
  [types.SUCCESS]: getExtendNormalized(getSuccessListHandler, favCoupons),
  [types.SUCCESS_PAGINATED]: getExtendNormalized(
    getSuccessListHandler,
    favCoupons,
    { attach: true },
  ),
  [types.FAILURE]: getFailureHandler(),
  [detailsTypes.REMOVE_COUPON]: softRemoveHandler,
  [types.RELOAD_FAVOURITES]: state => state,
  [types.TOGGLE_FAVOURITE]: toggleFavourite,
};

export default createReducer(EXTEND_NORMALIZED_INITIAL_STATE, HANDLERS);